import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import DOMPurify from 'dompurify';

let openForTarget = null;
let popover = null;

$(() => {
  $('body.resource_mit_license_detail [data-calcpopover]').bind('click', e => {
    e.stopPropagation();
    const target = $(e.delegateTarget);

    popover?.hide()
    if (openForTarget?.get(0) === target?.get(0)) {
      openForTarget = null;
      return;
    }


    $.ajax({
      type: 'GET',
      url: $(e.delegateTarget).data('calcpopover'),
      data: target.attr('alt'),
      dataType: 'html',
      context: this,
      success: data => {
        popover = new bootstrap.Popover(target, {
          placement: 'left',
          trigger: 'focus',
          html: true,
          sanitizeFn: content => DOMPurify.sanitize(content),
          content: data
        });
        popover.show();
        openForTarget = target;
      }
    });
  });
});
